addTypename